import { motion } from 'motion/react';
import { TWITCH_CHANNEL_URL } from '../../content/site';
import { spring } from '../../lib/motion';
import { plausibleEventClass } from '../../lib/plausible';

/**
 * "Watch on the HyperX Twitch channel" CTA. The Figma button component's
 * Default and Hover states are stacked and crossfaded (no swap flicker),
 * with a spring scale for tactility. `compact` is the in-hero variant
 * (7.27 live hero, HX-36): tighter text-to-button gap to sit inside the
 * hero's own rhythm. `location` labels the Plausible `CTA Click` event so the
 * hero and PRE/POST-band placements are distinguishable in the dashboard.
 */
export function TwitchPromo({
  compact = false,
  location = 'watch-band',
  href = TWITCH_CHANNEL_URL,
}: {
  compact?: boolean;
  location?: string;
  /** Phase-dependent destination (HX-44) — see twitchUrlForPhase. Defaults to
   *  the channel so any future caller without a phase still links somewhere
   *  sensible. */
  href?: string;
}) {
  return (
    <div
      className={`flex w-full flex-col items-center px-5 ${
        compact ? 'gap-[clamp(0.75rem,1.5vw,1.25rem)]' : 'gap-[clamp(1.25rem,3vw,2.5rem)]'
      }`}
    >
      <p className="text-glow max-w-content text-center font-heading text-[clamp(0.95rem,1.25vw,1.5rem)] uppercase tracking-wide text-brand-white">
        Watch on the HyperX Twitch channel
      </p>
      <motion.a
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label="HyperX on Twitch (opens in a new tab)"
        whileHover="hover"
        whileTap={{ scale: 0.97 }}
        transition={spring.tap}
        className={`group relative block w-[clamp(9rem,18vw,21.9rem)] ${plausibleEventClass(
          'CTA Click',
          { location },
        )}`}
        style={{ aspectRatio: '385.25 / 126.11' }}
      >
        <img
          src="/assets/images/buttons/twitch-default.svg"
          alt=""
          className="absolute inset-0 h-full w-full transition-opacity duration-200 group-hover:opacity-0"
        />
        <img
          src="/assets/images/buttons/twitch-hover.svg"
          alt=""
          className="glow-twitch-hover absolute inset-0 h-full w-full opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        />
      </motion.a>
    </div>
  );
}
